import React, {useContext, useEffect} from "react";
import Grid from "@mui/material/Grid2";
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import ProjectSummaryTable from "../Components/Projects/ProjectSummaryTable";
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';
import Box from "@mui/material/Box";
import {IsOnboardedContext} from "../Contexts/IsOnboardedContext";
import Typography from "@mui/material/Typography";
import {Paper} from "@mui/material";
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import {useTheme} from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";

const Home = () => {
    const context = useContext(IsOnboardedContext);
    const theme = useTheme();
    useEffect(() => {
        document.title = 'Home - CPC';
    }, []);
    
    return <div>
        <Grid container
              spacing={3}
              direction="row"
              justifyContent='left'
        >
            <Grid size={{ xs: 12 }}>
                <Typography variant="h2" sx={{ ml: 0.5}}>{!!context?.user?.givenName ? `Welcome ${context?.user?.givenName}!` : "Welcome!"}</Typography>
            </Grid>
            <Grid size={{ xs: 12}} display={{xs: 'none', sm: 'block'}}>
                <Box display='flex'>
                    <Link to="/projects/new">
                        <Button sx={{ width: {sm: 175, md: 200}, height: {sm: 175, md: 200}, mr: 1 }}>
                            <Paper sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Avatar sx={{
                                    mt: {sm: 3, md: 5}, mb: 2,
                                    width: {xs: 60, md: 80},
                                    height: {xs: 60, md: 80},
                                    backgroundColor: theme.palette.primary.main,
                                    border: `1px solid ${theme.palette.primary.main}`,
                                    color: theme.palette.info.main,
                                }}>
                                    <RequestQuoteOutlinedIcon sx={{ fontSize: {xs: 45, md: 60}, color: 'white'}} />
                                </Avatar>
                                <Typography variant={'body1'} sx={{fontWeight: 'bold', px: 1}}>New Project</Typography>
                            </Paper>
                        </Button>
                    </Link>
                    <Link to="/Clients">
                        <Button sx={{ width: {sm: 175, md: 200}, height: {sm: 175, md: 200}, mx: 1 }}>
                            <Paper sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Avatar sx={{
                                    mt: {sm: 3, md: 5}, mb: 2,
                                    width: {xs: 60, md: 80},
                                    height: {xs: 60, md: 80},
                                    backgroundColor: theme.palette.tertiary.secondary,
                                    border: `1px solid ${theme.palette.tertiary.secondary}`,
                                    color: theme.palette.info.main,
                                }}>
                                    <GroupsOutlinedIcon sx={{ fontSize: {xs: 45, md: 60}, color: 'white'}} />
                                </Avatar>
                                <Typography variant={'body1'} sx={{fontWeight: 'bold', px: 1}}>Manage Clients</Typography>
                            </Paper>
                        </Button>
                    </Link>
                    <Link to="/Products">
                        <Button sx={{ width: {sm: 175, md: 200}, height: {sm: 175, md: 200}, ml: 1 }}>
                            <Paper sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Avatar sx={{
                                    mt: {sm: 3, md: 5}, mb: 2,
                                    width: {xs: 60, md: 80},
                                    height: {xs: 60, md: 80},
                                    backgroundColor: theme.palette.tertiary.secondary,
                                    border: `1px solid ${theme.palette.tertiary.secondary}`,
                                    color: theme.palette.info.main,
                                }}>
                                    <InventoryOutlinedIcon sx={{ fontSize: {xs: 45, md: 60}, color: 'white'}} />
                                </Avatar>
                                <Typography variant={'body1'} sx={{fontWeight: 'bold', px: 1}}>Manage Products</Typography>
                            </Paper>
                        </Button>
                    </Link>
                </Box>
            </Grid>
            <Grid size={{ xs: 12}} display={{xs: 'block', sm: 'none'}}>
                <Box display='flex' alignItems='center' justifyContent='center'>
                    <Link to="/projects/new">
                        <Button sx={{ width: '90vw', height: 175, py: 0 }}>
                            <Paper sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Avatar sx={{
                                    mt: 3, mb: 2,
                                    width: 80,
                                    height: 80,
                                    backgroundColor: theme.palette.primary.main,
                                    border: `1px solid ${theme.palette.primary.main}`,
                                    color: theme.palette.info.main,
                                }}>
                                    <RequestQuoteOutlinedIcon sx={{ fontSize: 60, color: 'white'}} />
                                </Avatar>
                                <Typography variant={'body1'} sx={{fontWeight: 'bold', px: 1}}>New Project</Typography>
                            </Paper>
                        </Button>
                    </Link>
                </Box>
            </Grid>
            <Grid size={{ xs: 12}} display={{xs: 'block', sm: 'none'}}>
                <Box display='flex' alignItems='center' justifyContent='center'>
                    <Link to="/Clients">
                        <Button sx={{ width: '90vw', height: 60, py: 0 }}>
                            <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', backgroundColor: theme.palette.tertiary.secondary}}>
                                <Typography variant={'body1'} sx={{fontWeight: 'bold', px: 1,  color: 'white'}}>Manage Clients</Typography>
                            </Paper>
                        </Button>
                    </Link>
                </Box>
            </Grid>
            <Grid size={{ xs: 12}} display={{xs: 'block', sm: 'none'}}>
                <Link to="/Products">
                    <Box display='flex' alignItems='center' justifyContent='center'>
                        <Button sx={{ width: '90vw', height: 60, py: 0 }}>
                            <Paper sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%', backgroundColor: theme.palette.tertiary.secondary}}>
                                <Typography variant={'body1'} sx={{fontWeight: 'bold', px: 1, color: 'white'}}>Manage Products</Typography>
                            </Paper>
                        </Button>
                    </Box>
                </Link>
            </Grid>
            <Grid size={{ xs: 12 }}>
                <Typography variant="h3" sx={{ ml: 0.5, my: 1}}>Projects</Typography>
            </Grid>
            <Grid size={{ xs: 12 }} sx={{ ml: 0.5}}>
                <ProjectSummaryTable />
            </Grid>
        </Grid>
    </div>
};

export default Home;